import { isEmpty } from 'lodash'

const ALTERNATIVES_ORDER = ['A', 'B', 'C', 'D', 'E']

const compareLetters = (first, second) => {
  const firstIndex = ALTERNATIVES_ORDER.indexOf(first?.toUpperCase())
  const secondIndex = ALTERNATIVES_ORDER.indexOf(second?.toUpperCase())
  return firstIndex - secondIndex
}

const worstLetter = (letters) =>
  letters.reduce((current, candidate) =>
    !current || compareLetters(candidate, current) > 0 ? candidate : current,
  )

const recommendedAlternative = ({
  decisions,
  applicability,
  meritFloor,
  claimedLetter,
  auditorLetter,
}) => {
  const decisionList = Object.values(decisions || {})

  const fallbacks = decisionList
    .filter((decision) => decision.is_admissible)
    .filter(
      (decision) =>
        decision.target_alternative_feasible === false &&
        decision.recommended_fallback_letter,
    )
    .map((decision) => decision.recommended_fallback_letter)

  if (!isEmpty(fallbacks)) return worstLetter(fallbacks)

  if (meritFloor?.best_defensible_letter)
    return meritFloor.best_defensible_letter

  const targetLetter =
    applicability?.target_alternative ||
    applicability?.effective_claimed_letter ||
    claimedLetter ||
    null

  return targetLetter ?? auditorLetter ?? null
}

export default recommendedAlternative
